/* eslint-disable import/prefer-default-export */
const MSAL_CLIENT_ID = process.env.REACT_APP_MICROSOFT_CLIENT_ID;

export const msalConfig = {
  auth: {
    clientId: MSAL_CLIENT_ID,
    authority: 'https://login.microsoftonline.com/common',
    redirecturi: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
  },
};

export const loginRequest = {
  scopes: ['User.Read'],
};
